export default __webpack_public_path__ + "static/media/rectangle.c4bc1f98.svg";